export default __webpack_public_path__ + "static/media/Boots of the Crawling Chaos.d21e1778.jpg";